import ErrorPage from "./ErrorPage";
import SignUp from "./auth/sign-up";
import SignIn from "./auth/sign-in";
import { ForgotPassword, CreateNewPassword } from "./auth/password-recovery";
import Home from "./dashboard/home/Home";
import SurveyForm from "./SurveyForm";

export {
    ErrorPage,
    SignUp,
    SignIn,
    ForgotPassword, 
    CreateNewPassword,
    Home,
    SurveyForm
}